export function Field({ label, required, help, error, children, htmlFor }) {
  return (
    <div className="field">
      <label className="field-label" htmlFor={htmlFor}>
        {label}
        {required ? <span className="field-required">*</span> : null}
      </label>
      {children}
      {error ? <div className="field-error">{error}</div> : help ? <div className="field-help">{help}</div> : null}
    </div>
  );
}

export function Input({ id, ...props }) {
  return <input id={id} className="input" {...props} />;
}

export function MonoInput({ id, ...props }) {
  return <input id={id} className="input input-mono" {...props} />;
}

export function Textarea({ id, ...props }) {
  return <textarea id={id} className="input" {...props} />;
}
